import { useTour } from '@reactour/tour';
import { useEffect } from 'preact/hooks';

import { useSelector } from '@/redux/helper';
import { selectCanAccessEducatorsApp, selectHasGuidedExperienceFeature } from '@/redux/selectors/users';

const useHabitatTour = () => {
  const { setIsOpen } = useTour();
  const canAccessEducatorsApp = useSelector(selectCanAccessEducatorsApp);
  const educatorOnboarding = useSelector((state) => state.user.educatorOnboarding);
  const hasActiveL1Plan = useSelector(selectHasGuidedExperienceFeature);
  const isSpeedyFlowOpen = useSelector((state) => !!state.modals.speedyFlow?.visible);

  useEffect(() => {
    if (hasActiveL1Plan) {
      setIsOpen(false);
      return undefined;
    }

    const hasNotCompleted = !educatorOnboarding?.isOnboardingCompleted;
    const hasNotSkipped = !educatorOnboarding?.isOnboardingSkipped;
    const shouldShowTour = canAccessEducatorsApp && hasNotCompleted && hasNotSkipped;

    // Not while the Speedy Flow has them. It is asking for an account, an address, or a payment,
    // and a tour starting over the top of that talks past the visitor entirely. `isSpeedyFlowOpen`
    // is a dependency, so the tour arms itself the moment the flow is finished or dismissed —
    // deliberately only *starting* late, never closing a tour already under way.
    if (!shouldShowTour || isSpeedyFlowOpen) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, [setIsOpen, canAccessEducatorsApp, educatorOnboarding, hasActiveL1Plan, isSpeedyFlowOpen]);
};

export default useHabitatTour;
